module.exports = __webpack_public_path__ + "media/components/src/assets/images/icon-close/icon-close-8823ad73944e23cd69da3e81ee09e8e0.svg";